if (!customElements.get('wls-pdp-accordion')) {
  class WLSPDPAccordion extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        active: 'active',
        accordionItem: 'js-pdp-accordion-item',
        accordionTrigger: 'js-pdp-accordion-trigger',
        accordionContent: 'js-pdp-accordion-content',
      };

      this.selectors = {
        accordionItems: this.querySelectorAll(`.${this.classes.accordionItem}`),
      };
    }

    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      if (this.selectors.accordionItems.length > 0) {
        this.selectors.accordionItems.forEach((item) => {
          const itemTrigger = item.querySelector(`.${this.classes.accordionTrigger}`);
          if (itemTrigger) {
            itemTrigger.addEventListener('click', this.toggleAccordion.bind(this));
          }
        });
      }
    }

    toggleAccordion(e) {
      const item = e.currentTarget.closest(`.${this.classes.accordionItem}`);
      const isOpen = item.classList.contains(this.classes.active);
      const itemContent = item.querySelector(`.${this.classes.accordionContent}`);
      const itemTrigger = item.querySelector(`.${this.classes.accordionTrigger}`);

      if (!itemContent) return;

      if (isOpen) {
        // If this is the first time closing a default-open accordion, set the actual height first
        if (itemContent.classList.contains('default-open')) {
          itemContent.classList.remove('default-open');
          itemContent.style.maxHeight = `${itemContent.scrollHeight}px`;
          // Force a reflow to ensure the transition works
          itemContent.offsetHeight;
        }
        itemContent.style.maxHeight = '0px';
        item.classList.remove(this.classes.active);
        if (itemTrigger) {
          itemTrigger.setAttribute('aria-expanded', 'false');
        }
        if (itemContent) {
          itemContent.setAttribute('aria-hidden', 'true');
        }
      } else {
        this.closeAllAccordions();
        item.classList.add(this.classes.active);
        itemContent.style.maxHeight = `${itemContent.scrollHeight}px`;
        if (itemTrigger) {
          itemTrigger.setAttribute('aria-expanded', 'true');
        }
        if (itemContent) {
          itemContent.setAttribute('aria-hidden', 'false');
        }
      }
    }

    /**
     * Close all accordions.
     *
     * @returns {void}
     */
    closeAllAccordions() {
      this.selectors.accordionItems.forEach((item) => {
        const itemContent = item.querySelector(`.${this.classes.accordionContent}`);
        const itemTrigger = item.querySelector(`.${this.classes.accordionTrigger}`);

        if (itemContent) {
          itemContent.style.maxHeight = '0px';
          itemContent.setAttribute('aria-hidden', 'true');
        }
        if (itemTrigger) {
          itemTrigger.setAttribute('aria-expanded', 'false');
        }
        item.classList.remove(this.classes.active);
      });
    }
  }

  window.customElements.define('wls-pdp-accordion', WLSPDPAccordion);
}
